<div class="arrow_box bg-dark " *ngIf="bettingSlipStatus ">
  <span class="fa fa-chevron-up" style="font-size: 1.5rem" *ngIf="!bettingInfo"
    (click)="bettingInfo = !bettingInfo"></span>
  <span class="fa fa-chevron-down" style="font-size: 1.5rem" *ngIf="bettingInfo"
    (click)="bettingInfo = !bettingInfo"></span>
</div>


<div class="bet-slip-footer bg-dark" *ngIf="bettingSlipStatus && bettingInfo ">
  <app-your-betting-info [info]="cuponInfo" [raceDate]="raceDate" (clearAll)="clearBetSlip()"></app-your-betting-info>
</div>


<div class="stickyBar font-weight-normal my-3 bg-dark px-3 py-2" *ngIf="bettingSlipStatus">
  <div class="d-flex flex-column text-white w-full" *ngIf="bettingSlipStatus ">
    <!-- Bet Cart Price Info  -->
    <ng-container *ngIf="betService.allAddedBetsInCart$.value.length > 0">
      <ng-container *ngFor="let bet of allBetsOnCart$ | async">
        <div class="d-flex flex-row justify-content-between align-items-center border-bottom my-1">
          <div>
            <span>{{ bet?.selectedBet?.name | bettingType | translate| capitalizeFirst}} : </span>
            <span>{{ bet?.numberofBets }}</span>
          </div>
          <span>{{ bet?.totalPrice| number: "1.2-2" }} {{authService.currentCurrency$ | async | uppercase}}</span>
        </div>
      </ng-container>
    </ng-container>

    <div class="d-flex flex-row justify-content-between align-items-center border-bottom my-1"
      *ngIf="this.betService.showCurrentBet$ | async">
      <div>
        <span> {{ cuponInfo?.selectedBet?.name | bettingType | translate| capitalizeFirst }}: </span>
        <span>{{ betService.numberofBets}}</span>
      </div>
      <span>{{ betService.totalPrice | number: "1.2-2" }} {{authService.currentCurrency$ | async | uppercase}}</span>
    </div>

    <div class="d-flex flex-row justify-content-between align-items-center my-1">
      <div>
        {{"Total" | translate}}
      </div>
      <span>{{ betService.totalAllBetsOnCart + betService.totalPrice | number: "1.2-2" }} {{authService.currentCurrency$
        | async | uppercase}}</span>
    </div>
    <!--  Bet Cart Price Info  -->
  </div>

  <div class="d-flex row text-white justify-content-between align-items-stretch">
    <div class="d-flex flex-column justify-content-start align-items-stretch">
      <div class="d-flex flex-column mb-3">
        <!-- <span>{{ "RACES.NUMBER_OF_BETS" | translate }}:
          {{ betService.numberofBets }}</span> -->
      </div>
      <div class="d-flex flex-row justify-content-start align-items-center">
        <span class="pr-2">{{ "RACES.STAKES" | translate }}:</span>
        <form class="d-flex flex-row justify-content-start align-items-stretch"
          [formGroup]="betService.raceDetailsForm">
          <button class="btn btn-sm btn-warning font-xl p-0 increase-btn left" (click)="decrease()" style="width: 30px">
            -
          </button>
          <input class="stake-in text-center border" style="width: 50px; margin-right: -1px; margin-left: -1px"
            [class.stake-red]="betService.raceDetailsForm.invalid === true" formControlName="selectedStake"
            [(ngModel)]="betService.selectedStake" appTwoDigitDecimaNumber />
          <button class="btn btn-sm btn-warning font-xl p-0 increase-btn right" (click)="increase()"
            style="width: 30px">
            +
          </button>
        </form>
      </div>
    </div>
    <div class="d-flex flex-column justify-content-between align-items-end">
      <div class="col">
        <!-- {{ "RACES.TOTAL" | translate }}:
        {{ betService.totalPrice | number: "1.2-2" }} TND -->
      </div>
      <button [disabled]="betService.numberofBets <= 0 || betService.placeBetSpinner"
        class="btn btn-md btn-warning d-flex" (click)="showConfirmBetPopup()" [ngClass]="{
          'kt-spinner kt-spinner--right kt-spinner--light':
            betService.placeBetSpinner
        }">
        <i *ngIf="betService.placeBetSpinner" class="pi pi-spin pi-spinner text-primary mr-2"
          style="font-size: 1.5rem"></i>
        {{ "RACES.PLACE_BET" | translate }}
      </button>
    </div>
  </div>
</div>